import * as React from 'react';
import { pickProps } from "../../../utils/miscUtil";
var propNames = ['onMouseEnter', 'onMouseLeave'];
export default function useRootProps(props) {
  return React.useMemo(function () {
    return pickProps(props, propNames);
  }, [props]);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-picker/es/PickerInput/Selector/hooks/useRootProps.js
// module id = 738
// module chunks = 0